module.exports = __webpack_public_path__ + "assets/Bell-solid.21d2c4dc.svg";